<nb-card class="card-scroll">
	<nb-card-header class="card-header-title">
		<div class="card-header-title">
			<ngx-back-navigation></ngx-back-navigation>
			<h4>
				<ngx-header-title [allowEmployee]="false">
					{{ 'CANDIDATES_PAGE.MANAGE_INTERVIEWS.MANAGE_INTERVIEWS' | translate }}
				</ngx-header-title>
			</h4>
		</div>
		<div>
			<button 
				nbButton
				status="primary"
				(click)="addInterview()"
			>
				<nb-icon icon="plus-outline"></nb-icon>
				{{ 'CANDIDATES_PAGE.EDIT_CANDIDATE.INTERVIEW.ADD_INTERVIEW' | translate }}
			</button>
		</div>
	</nb-card-header>
	<nb-card-body>
		<nb-route-tabset [tabs]="tabs" fullWidth></nb-route-tabset>
	</nb-card-body>
</nb-card>
